import { Angular2Csv } from 'angular2-csv';
import { AdvancedSearchResultMemberItemArray, AdvancedSearchResultMemberItem } from '../models/domain/advanced.searche.results';
import { AdvancedSearchItem } from '../models/domain/advanced.search.item';
import { BillingCycleTypes } from '../models/domain/invoice';
import { LicenseStatusTypes } from '../models/domain/license';
import { SalesItemArray } from '../models/ss-api/responses/sales.item';
import { VendorStatisticsItemArray } from '../models/ss-api/responses/vendor.statistics.response';
import { ProductStatusPipe } from '../pipes/product.status.pipe';
import { Member } from '../models/domain/member';

export class ExportDataManager {

    Options: any;
    Headers: Array<string>;

    ResultData: Array<any>
    ExportData: Array<any>

    productStatusPipe: ProductStatusPipe = new ProductStatusPipe;

    constructor(  ) {
    }


    ExportVendorStatistics(data: VendorStatisticsItemArray, startDate: Date, endDate: Date) {

        this.GenerateVendorStatisticsExportData(data, startDate, endDate);

        this.Headers = new Array<string>();
        this.Headers.push('Vendor');
        this.Headers.push('File Name');
        this.Headers.push('Label');
        this.Headers.push('Start Date')
        this.Headers.push('End Date')
        this.Headers.push('Insertion Count');

        // prepare export settings
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: this.Headers
        };

        // export
        new Angular2Csv(this.ExportData, 'Vendor Statistics Export', options);

    }

    private GenerateVendorStatisticsExportData(data: VendorStatisticsItemArray, startDate: Date, endDate: Date): void {

        this.ExportData = new Array<any>();

        data.forEach(x => {
            let expItem = new Object();

            expItem['Vendor'] = this.GetStringData(x.VendorName);
            expItem['File Name'] = this.GetStringData(x.FileName);
            expItem['Label'] = this.GetStringData(x.ItemLabel);
            expItem['Start Date'] = this.getDateFormat(startDate);
            expItem['End Date'] = this.getDateFormat(endDate);
            expItem['Insertion Count'] = x.Count;

            this.ExportData.push(expItem);
        });
    }

    getDateFormat(date: Date) {

        let returnDate = '';

        let dd = date.getDate();
        let mm = date.getMonth() + 1; // because January is 0!
        let yyyy = date.getFullYear();



        if (mm < 10) {
            returnDate += `0${mm}/`;
        } else {
            returnDate += `${mm}/`;
        }

        if (dd < 10) {
            returnDate += `0${dd}/`;
        } else {
            returnDate += `${dd}/`;
        }

        returnDate += yyyy;
        return returnDate;
    }

    ExportSalesStatistics(data: SalesItemArray) {

        this.GenerateSalesStatisticsExportData(data);

        this.Headers = new Array<string>();
        this.Headers.push('Date');
        this.Headers.push('Name'); // Was Member Name
        // this.Headers.push("Designer Name");
        this.Headers.push('Company');
        this.Headers.push('License Key');
        this.Headers.push('Sales Rep');
        // this.Headers.push("Sales Type");
        this.Headers.push('Status');
        this.Headers.push('Product');
        this.Headers.push('Cycle');
        this.Headers.push('Amount');

        // prepare export settings
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: this.Headers
        };

        // export
        new Angular2Csv(this.ExportData, 'Sales Statistics Export', options);

    }


    // generate the result data array
    private GenerateSalesStatisticsExportData(data: SalesItemArray): void {

        this.ExportData = new Array<any>();


        data.forEach(x => {
            let expItem = new Object();

            expItem['Date'] = this.FixDate(x.DateTimeCreated);
            expItem['Name'] = this.GetStringData(x.MemberName);
            // expItem["Designer Name"] = this.GetStringData(x.DesignerName);
            expItem['Company'] = this.GetStringData( x.CompanyName );
            expItem['License Key'] = this.GetStringData(x.LicenseKey);
            expItem['Sales Rep'] = this.GetStringData(x.SalesRep);
            // expItem["Sales Type"] = this.GetStringData(x.LeadSource);
            expItem['Status'] = this.GetStringData( this.productStatusPipe.transform( x.Status ));
            expItem['Product'] = this.GetStringData(x.ProductName);
            expItem['Cycle'] = this.GetStringData(x.BillingCycle);
            expItem['Amount'] = x.Amount;

            this.ExportData.push(expItem);
        });


    }



    ExportSearchResults(request: AdvancedSearchItem, data: AdvancedSearchResultMemberItemArray) {

        this.ProcessSearchResultsData(request, data);

        // prepare export settings
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: this.Headers
        };

        // export
        new Angular2Csv(this.ExportData, 'Search Results Export', options);

    }

    ProcessSearchResultsData(request: AdvancedSearchItem, data: AdvancedSearchResultMemberItemArray = undefined) {

        if (data != undefined)
            this.ResultData = data;

        // generate headers
        this.GenerateSearchResultsHeaders(request);

        // generate the result data
        this.GenerateSearchResultsExportData(request);

    }


    // generate the result data array
    private GenerateSearchResultsExportData(request: AdvancedSearchItem): void {

        this.ExportData = new Array<any>();

        // loop through all the results
        this.ResultData.forEach(item => {

            // do we have to export license keys?
            if (request.showCDKey &&
                item.Licenses != undefined) {

                // export all keys
                let index = 0;
                item.Licenses.forEach(x => {

                    let newItem = this.ConvertSearchResultsToExportDataItem(request, item, index);
                    this.ExportData.push(newItem);
                    index++;
                })

            } else {

                // export normal
                let newItem = this.ConvertSearchResultsToExportDataItem(request, item);
                this.ExportData.push(newItem);
            }

        })

    }

    private GetStringData(input: string): string {
        if (input == undefined || input == null)
            return '';
        else
            return input;
    }

    private FixDate(input: Date): string {
        if (input.getFullYear() < 1990)
            return '';
        else
            return (input.getMonth() + 1) + '/' + input.getDate() + '/' + input.getFullYear();
    }

    private NameForMemberType(type: number): string {
        return Member.GetMemberPersonType(type);
    }


    private ConvertSearchResultsToExportDataItem(request: AdvancedSearchItem, item: AdvancedSearchResultMemberItem, licenseIndex = 0): any {

        let expItem = new Object();

        if (request.showMemberID)
            expItem['MemberID'] = this.GetStringData(item.ID.toString());

        if (request.showMemberType)
            expItem['MemberType'] = this.GetStringData(Member.GetMemberPersonType(item.MemberType));


        if (request.showFirstName)
            expItem['FirstName'] = this.GetStringData(item.FirstName);

        if (request.showLastName)
            expItem['LastName'] = this.GetStringData(item.LastName);

        if (request.showEmail)
            expItem['Email'] = this.GetStringData(item.Email);

        if (request.showCompanyName)
            expItem['Company'] = this.GetStringData(item.CompanyName);

        if (request.showAddress1)
            expItem['Address1'] = this.GetStringData(item.Address1);

        if (request.showCity)
            expItem['City'] = this.GetStringData(item.City);

        if (request.showState)
            expItem['State'] = this.GetStringData(item.State);

        if (request.showZipCode)
            expItem['ZipCode'] = this.GetStringData(item.ZipCode);

        if (request.showCountry)
            expItem['Country'] = this.GetStringData(item.Country);

        if (request.showPhone1)
            expItem['Phone1'] = this.GetStringData(item.Phone1);

        if (request.showPhone2)
            expItem['Phone2'] = this.GetStringData(item.Phone2);

        if (request.showFax)
            expItem['Fax'] = this.GetStringData(item.Fax);



        // GET SALES REP
        if (request.showSalesRep &&
            item.License != undefined)
            // add license by index
            expItem['SalesRep' + licenseIndex] = this.GetStringData(item.License.SalesRepName);

        if (request.showCreditCardLastFour)
            expItem['CreditCardLastFour'] = this.GetStringData(item.CreditCardLastFour);

        // GET BILLING CYCLE
        if (request.showBillingCycle &&
            item.License != undefined)
            // add license by index
            expItem['BillingCycle' + licenseIndex] = BillingCycleTypes[item.License.BillingCycle];

        // GET NEXT BILL DATE
        if (request.showNextBillDate &&
            item.License != undefined)
            // add license by index
            expItem['NextBillDate' + licenseIndex] = this.FixDate(item.License.NextBillDate);

        // ..
        if (request.showCDKey &&
            item.License != undefined)
            // add license by index
            expItem['LicenseKey' + licenseIndex] = this.GetStringData(item.License.Key);

        if (request.showVersion &&
            item.License != undefined)
            // add license by index
            expItem['Version' + licenseIndex] = this.GetStringData(item.License.Version);

        if (request.showDesignerName &&
            item.License != undefined)
            // add license by index
            expItem['DesginerName' + licenseIndex] = this.GetStringData(item.License.DesignerName);

        if (request.showProductID &&
            item.License != undefined)
            // add license by index
            expItem['PackageType' + licenseIndex] = this.GetStringData(item.License.ProductName);

        if (request.showStatus &&
            item.License != undefined)
            // add license by index
            expItem['Status' + licenseIndex] = LicenseStatusTypes[item.License.Status];

        if (request.showCreationDate &&
            item.License != undefined)
            // add license by index
            expItem['CreationDate' + licenseIndex] = this.FixDate(item.License.CreationDate);

        if (request.showExpirationDate &&
            item.License != undefined)
            // add license by index
            expItem['ExpirationDate' + licenseIndex] = this.FixDate(item.License.CancellationDate);



        if (request.showTags)
            expItem['Tags'] = this.GetStringData(item.Tags);

        if (request.showBillingAmount)
            expItem['BillingAmount' + licenseIndex] = this.GetStringData(item.License.BillingAmount.toString());

        // return the converted item
        return expItem;

    }


    // generate the headers of the CSV file
    private GenerateSearchResultsHeaders(request: AdvancedSearchItem): void {

        this.Headers = new Array<string>();

        // we need to generate the headers and the result items in the same order
        // so that the data matches the header title


        if (request.showMemberID)
            this.Headers.push('MemberID');

        if (request.showMemberType)
            this.Headers.push('Member Type');

        if (request.showFirstName)
            this.Headers.push('First Name');

        if (request.showLastName)
            this.Headers.push('Last Name');

        if (request.showEmail)
            this.Headers.push('Email');

        if (request.showCompanyName)
            this.Headers.push('Company');

        if (request.showAddress1)
            this.Headers.push('Address');

        if (request.showCity)
            this.Headers.push('City');

        if (request.showState)
            this.Headers.push('State');

        if (request.showZipCode)
            this.Headers.push('Zip Code');

        if (request.showCountry)
            this.Headers.push('Country');

        if (request.showPhone1)
            this.Headers.push('Phone');

        if (request.showPhone2)
            this.Headers.push('Phone 2');

        if (request.showFax)
            this.Headers.push('Fax');

        if (request.showSalesRep)
            this.Headers.push('Sales Rep');


        if (request.showCreditCardLastFour)
            this.Headers.push('CC Last 4');

        if (request.showBillingCycle)
            this.Headers.push('Billing Cycle');

        if (request.showNextBillDate)
            this.Headers.push('Next Bill Date');

        if (request.showCDKey)
            this.Headers.push('License Key');

        if (request.showVersion)
            this.Headers.push('Version');

        if (request.showDesignerName)
            this.Headers.push('Designer Name');

        if (request.showProductID)
            this.Headers.push('Product');

        if (request.showStatus)
            this.Headers.push('Status');

        if (request.showCreationDate)
            this.Headers.push('Start Date');

        if (request.showExpirationDate)
            this.Headers.push('End Date');

        if (request.showTags)
            this.Headers.push('Tags');

        if (request.showBillingAmount)
            this.Headers.push('Billing Amount');

    }


}
